<template>
  <div class="info_wrap">
    <p class="title">委托协议寄送地址</p>
    <el-form
      :model="myData"
      :rules="rules"
      ref="form"
      label-width="100px"
      class="info_form"
      :label-position="labelPosition"
    >
      <el-form-item label="联系人" prop="entrustsendpsn">
        <el-input
          v-model="myData.entrustsendpsn"
          placeholder="请填写"
        />
      </el-form-item>
      <el-form-item label="联系电话" prop="entrustsendtel">
        <el-input
          v-model="myData.entrustsendtel"
          placeholder="请填写"
        />
      </el-form-item>
      <el-form-item label="邮箱地址" prop="entrustsendemail">
        <el-input
          v-model="myData.entrustsendemail"
          placeholder="请填写"
        />
      </el-form-item>
      <el-form-item label="详细地址" prop="entrustsendaddress">
        <el-input
          v-model="myData.entrustsendaddress"
          placeholder="请填写"
        />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    myDisabled() {
      return this.disabled;
    },
  },
  data() {
    return {
      labelPosition: "top",
      myData: this.data,
      rules: {
        entrustsendpsn: [
          { required: true, message: "请填写联系人", trigger: "blur" },
        ],
        entrustsendtel: [
          { required: true, message: "请填写联系电话", trigger: "blur" },
        ],
        entrustsendaddress: [
          { required: true, message: "请填写详细地址", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    async validate() {
      let result = undefined;
      await this.$refs.form.validate((valid) => {
        result = valid;
      });
      return result;
    },
    resetFields() {
      this.$refs.form.resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
.info_wrap {
  .title {
    margin-bottom: 24px;
    font-size: 20px;
    font-weight: 600;
  }
}

/*样式穿透*/
.otherInfo ::v-deep .info_form {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}

.urgent_wrap ::v-deep .urgent {
  .urgent_btn {
    .red {
      color: red;
    }
  }
}
</style>
